<template>
  <v-container id="admindashboard" grid-list-md fluid>
    <v-card>
      <v-card-title class="headline" title--text>
        Admin Dashboard
        <v-spacer></v-spacer>
        <v-layout raw wrap align-center justify-center>
          <v-flex xs10 sm3 md4>
            <v-menu
              v-model="startDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="startDateFormatted"
                  label="Start Date"
                  persistent-hint
                  prepend-icon="event"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="startDate"
                no-title
                @input="startDateMenu = false"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs10 sm3 md4>
            <v-menu
              v-model="endDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="endDateFormatted"
                  label="End Date"
                  persistent-hint
                  prepend-icon="event"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="endDate"
                no-title
                @input="endDateMenu = false"
              ></v-date-picker>
            </v-menu>
          </v-flex>
        </v-layout>
        <v-spacer></v-spacer>
        <v-btn-toggle borderless dense v-model="historySelection">
          <v-btn text @click="changeInterval(29)">30 Days</v-btn>
          <v-btn text @click="changeInterval(89)">90 Days</v-btn>
          <v-btn text @click="changeInterval(daysSinceFY())">EoFY</v-btn>
        </v-btn-toggle>
      </v-card-title>
      <v-card-text>
        <v-row justify="space-between" no-gutters>
          <v-col cols="2">
            <total-received
              :startDate="startDate"
              :endDate="endDate"
            ></total-received>
          </v-col>
          <v-col cols="2">
            <total-con-spend
              :startDate="startDate"
              :endDate="endDate"
            ></total-con-spend>
          </v-col>

          <v-col cols="2">
            <gross-profit
              :startDate="startDate"
              :endDate="endDate"
            ></gross-profit>
          </v-col>

          <v-col cols="2">
            <contractor-gst-retained
              :startDate="startDate"
              :endDate="endDate"
            ></contractor-gst-retained>
          </v-col>
          <v-col cols="2">
            <total-expense
              :startDate="startDate"
              :endDate="endDate"
            ></total-expense>
          </v-col>
          <v-col cols="2">
            <net-profit :startDate="startDate" :endDate="endDate"></net-profit>
          </v-col>
        </v-row>
        <v-row justify="space-between" no-gutters>
          <v-col cols="12">
            <totals-lc :startDate="startDate" :endDate="endDate"></totals-lc>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <client-table :startDate="startDate" :endDate="endDate">
            </client-table>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <contractor-table :startDate="startDate" :endDate="endDate">
            </contractor-table>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <clients-pc :startDate="startDate" :endDate="endDate"></clients-pc>
          </v-col>
          <v-col cols="6">
            <contractor-pc
              :startDate="startDate"
              :endDate="endDate"
            ></contractor-pc>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import TotalsLC from "./TotalsLC.vue";
import ClientsPC from "./ClientsPC.vue";
import ContractorPC from "./ContractorPC.vue";
import ContractorGSTRetained from "./ContractorGSTRetained.vue";
import ClientTable from "./ClientTable.vue";
import ContractorTable from "./ContractorTable.vue";
import TotalReceived from "./TotalReceived.vue";
import TotalConSpend from "./TotalConSpend.vue";
import GorssProfit from "./GorssProfit.vue";
import TotalExpense from "./TotalExpense.vue";
import NetProfit from "./NetProfit.vue";
export default {
  components: {
    "totals-lc": TotalsLC,
    "clients-pc": ClientsPC,
    "contractor-pc": ContractorPC,
    "contractor-gst-retained": ContractorGSTRetained,
    "total-received": TotalReceived,
    "total-con-spend": TotalConSpend,
    "gross-profit": GorssProfit,
    "total-expense": TotalExpense,
    "net-profit": NetProfit,
    "client-table": ClientTable,
    "contractor-table": ContractorTable,
  },

  data() {
    return {
      historySelection: 0,
      //days: { 0: 30, 1: 90, 2: this.daysSinceFY() },
      startDateMenu: false,
      endDateMenu: false,
      endDateDT: new Date(),
      startDateDT: new Date(new Date().setDate(new Date().getDate() - 30)),
      startDate: "",
      endDate: "",
      startDateFormatted: "",
      endDateFormatted: "",
    };
  },
  created() {
    this.startDate = this.parseDate(this.startDateDT);
    this.endDate = this.parseDate(this.endDateDT);
    this.startDateFormatted = this.formatDate(this.startDate);
    this.endDateFormatted = this.formatDate(this.endDate);
  },
  watch: {
    startDate(val) {
      this.startDateFormatted = this.formatDate(this.startDate);
    },
    endDate(val) {
      this.endDateFormatted = this.formatDate(this.endDate);
    },
    startDateDT(val) {
      this.startDate = this.parseDate(this.startDateDT);
    },
    endDateDT(val) {
      this.endDate = this.parseDate(this.endDateDT);
    },
  },
  computed: {
    history() {
      return this.days[this.historySelection || 0];
    },
  },

  methods: {
    daysSinceFY() {
      let today = new Date();
      let startDate;
      if (today.getMonth() > 5) {
        startDate = new Date(today.getFullYear(), 6, 1);
      } else {
        startDate = new Date(today.getFullYear() - 1, 6, 1);
      }
      return Math.floor(
        (today.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24)
      );
    },

    changeInterval(interval) {
      (this.endDateDT = new Date()),
        (this.startDateDT = new Date(
          new Date().setDate(new Date().getDate() - interval)
        )),
        (this.startDate = this.parseDate(this.startDateDT));
      this.endDate = this.parseDate(this.endDateDT);
      this.startDateFormatted = this.formatDate(this.startDate);
      this.endDateFormatted = this.formatDate(this.endDate);
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      date = date.toLocaleDateString("en-AU");
      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
  },
};
</script>
